import { documentationActions } from '../../actions/constant';
import { applyHeldFromBilling } from './holdDailyNoteFromBillingReducer';
import { removeArchived } from '../dailySessionNotes/archiveDailySessionNoteReducer';
import { dailySessionNotes } from '../../actions/constant';

const {
  SUCCESS_GET_ALL_SUBMITTED_DOCUMENT,
  FAILURE_GET_ALL_SUBMITTED_DOCUMENT,
  LOADER_GET_ALL_SUBMITTED_DOCUMENT,
  RESET_GET_ALL_SUBMITTED_DOCUMENT,
  HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS,
} = documentationActions;

const intitialstate: object = {
  response: null,
  getSubmittedDocument: false,
  loader: false,
};

export const getAllSubmittedDocumentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_SUBMITTED_DOCUMENT: {
      return {
        ...state,
        getSubmittedDocument: true,
        response: action.payload?.data,
        loader: false,
      };
    }

    case FAILURE_GET_ALL_SUBMITTED_DOCUMENT:
      return {
        ...state,
        getSubmittedDocument: false,
        response: action.payload,
        loader: false,
      };

    case LOADER_GET_ALL_SUBMITTED_DOCUMENT:
      return {
        ...state,
        loader: true,
      };

    case HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS:
      return applyHeldFromBilling(state, action.payload);

    case dailySessionNotes.ARCHIVE_DAILY_SESSION_NOTE_SUCCESS:
      return removeArchived(state, action.payload);

    case RESET_GET_ALL_SUBMITTED_DOCUMENT:
      return intitialstate;
    default:
      return state;
  }
};
